module.exports = __webpack_public_path__ + "img/pets.0f5a466f.svg";